import React, { useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Label, Button, Input, FormFeedback } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

const CourseComponentModal = ({
  modal,
  toggle,
  isEdit,
  courseComponent,
  semesters = [],
  studyLevels = [],
  teachers = [],
  onSubmit
}) => {

  // 🔹 Préparer les options pour react-select
  /*const serviceOptions = internshipServices.map(service => ({
    value: service.id,
    label: service.name
  }));
  */

  // 🔹 Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
        id: courseComponent?.id || "",
        uuid: (courseComponent && courseComponent.uuid) || '',
        title: (courseComponent && courseComponent.title) || '',
        code: (courseComponent && courseComponent.code) || '',
        semester_id: (courseComponent && courseComponent.semester_id) || '',
        study_level_id: (courseComponent && courseComponent.study_level_id) || '',
        teacher_id: (courseComponent && courseComponent.teacher_id) || '',
        type: (courseComponent && courseComponent.type) || '',
    },
    formikSchema: Yup.object({
        name: Yup.string().required("Veuillez saisir le nom"),
        semester_id: Yup.number().required("Veuillez sélectionner le semestre"),
        study_level_id: Yup.number().required("Veuillez sélectionner le niveau d'étude"),
        teacher_id: Yup.number().required("Veuillez sélectionner l'enseignant"),
        type: Yup.string().required("Veuillez sélectionner le type"),
      
    }),
    onSubmit: values => {
      const payload = {
        ...values,
        semester_id: Number(values.semester_id), // 🔹 conversion string → number
        study_level_id: Number(values.study_level_id), // 🔹 conversion string → number
        teacher_id: Number(values.teacher_id), // 🔹 conversion string → number
        //internship_service_ids: values.internship_service_ids.map(Number)
      };
      onSubmit(payload);
      //formik.resetForm();

      
    }
  });

  return (
    <Modal isOpen={modal} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle}>
        {!!isEdit ? "Modifier - Élément constitutif" : "Ajouter - Élément constitutif"}
      </ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <Row>
            <Col className="col-12">
                <div className="mb-3">
                    <Label>Titre</Label>
                    <Input
                        name="title"
                        type="text"
                        placeholder="Titre"
                        validate={{
                            required: { value: true },
                        }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.title || ""}
                        invalid={
                            formik.touched.title && formik.errors.title ? true : false
                        }
                    />
                    {formik.touched.title && formik.errors.title ? (
                        <FormFeedback type="invalid">{formik.errors.title}</FormFeedback>
                    ) : null}
                </div>

                <div className="mb-3">
                    <Label>Code</Label>
                    <Input
                        name="code"
                        type="text"
                        placeholder="Code"
                        validate={{
                            required: { value: true },
                        }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.code || ""}
                        invalid={
                            formik.touched.code && formik.errors.code ? true : false
                        }
                    />
                    {formik.touched.code && formik.errors.code ? (
                        <FormFeedback type="invalid">{formik.errors.code}</FormFeedback>
                    ) : null}
                </div>
                                        
                                    
                                    
                <div className="mb-3">
                    <Label>Niveau d'étude</Label>
                    <Input
                        name="study_level_id"
                        type="select"
                        className="form-select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={
                            formik.values.study_level_id || ""
                        }
                        invalid={
                            formik.touched.study_level_id && formik.errors.study_level_id
                                ? true
                                : false
                        }
                    >
                        <option value="">-- Sélectionner --</option>
                            {studyLevels.map((c) => (
                            <option key={c.id} value={c.id}>{c.name}</option>
                            ))}

                    </Input>
                    {formik.touched.study_level_id && formik.errors.study_level_id ? (
                        <FormFeedback type="invalid">{formik.errors.study_level_id}</FormFeedback>
                    ) : null}
                </div>

                                        

                <div className="mb-3">
                    <Label>Professeur</Label>
                    <Input
                        name="teacher_id"
                        type="select"
                        className="form-select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={
                            formik.values.teacher_id || ""
                        }
                        invalid={
                            formik.touched.teacher_id && formik.errors.teacher_id
                                ? true
                                : false
                        }
                    >
                        <option value="">-- Sélectionner --</option>
                            {teachers.map((c) => (
                            //<option key={c.id} value={c.id}>{c.first_name}</option>
                            <option key={c.id} value={c.id}>{`${c.first_name} ${c.last_name}`}</option>
                            ))}

                    </Input>
                    {formik.touched.teacher_id && formik.errors.teacher_id ? (
                        <FormFeedback type="invalid">{formik.errors.teacher_id}</FormFeedback>
                    ) : null}
                </div>

                <div className="mb-3">
                    <Label>Type</Label>
                    <Input
                        name="type"
                        type="select"
                        value={formik.values.type || ""}
                        validate={{
                            required: { value: true },
                        }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                            formik.touched.type && formik.errors.type ? true : false
                        }
                        >
                        <option value="">Sélectionner</option>
                        <option value="Cour magistral">Cour magistral</option>
                        <option value="TP">TP (Travaux pratique)</option>
                        <option value="TD">TD (Travaux dirigés)</option>
                        <option value="TPE">TPE (Travaux personnel de l’étudiant)</option>
                        
                    </Input>
                    {formik.touched.type && formik.errors.type ? (
                        <FormFeedback type="invalid">{formik.errors.type}</FormFeedback>
                    ) : null}
                </div>

                                        

                <div className="mb-3">
                    <Label>Semestre</Label>
                    <Input
                        name="semester_id"
                        type="select"
                        className="form-select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={
                            formik.values.semester_id || ""
                        }
                        invalid={
                            formik.touched.semester_id && formik.errors.semester_id
                                ? true
                                : false
                        }
                    >
                        <option value="">-- Sélectionner --</option>
                            {semesters.map((c) => (
                            <option key={c.id} value={c.id}>{c.code}</option>
                            ))}

                    </Input>
                    {formik.touched.semester_id && formik.errors.semester_id ? (
                        <FormFeedback type="invalid">{formik.errors.semester_id}</FormFeedback>
                    ) : null}
                </div>

            </Col>
          </Row>

          <Row>
            <Col>
              <div className="text-end">
                <Button type="submit" color="primary">
                  {isEdit ? "Modifier" : "Enregistrer"}
                </Button>
              </div>
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default CourseComponentModal;
